import { render } from "./addtestimonial.vue?vue&type=template&id=104f5eb4&scoped=true"
import script from "./addtestimonial.vue?vue&type=script&lang=js"
export * from "./addtestimonial.vue?vue&type=script&lang=js"

import "./addtestimonial.vue?vue&type=style&index=0&id=104f5eb4&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104f5eb4"]])

export default __exports__